import { put, call, delay } from "redux-saga/effects";
// Actions
import {
  loginSuccess,
  loginFailure,
  loginClear,
  recoverPasswordSuccess,
  recoverPasswordFailure,
  logoutSuccess,
  logoutFailure,
  refreshTokenSaga_,
} from "../Login/Action";
// Libraries
import firebase from "firebase/app";
import "firebase/auth";

function onAuthStateChanged() {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        resolve(user);
      } else {
        reject("User not logged");
      }
    });
  });
}

export function* loginSaga(action) {
  try {
    const { email, password } = action.payload;
    const authFunction = yield call(firebase.auth);
    yield call(
      [authFunction, authFunction.signInWithEmailAndPassword],
      email,
      password
    );
    const token = yield call([
      authFunction.currentUser,
      authFunction.currentUser.getIdToken,
    ]);
    yield localStorage.setItem("token", token);
    yield localStorage.setItem("tokenExpiration", new Date().getTime());
    // Asyncronic call to auto-refresh tokens
    yield put(refreshTokenSaga_());
    const { displayName } = yield firebase.auth().currentUser;
    yield put(loginSuccess(displayName));
  } catch (error) {
    let errorMessage = "";
    switch (error.code) {
      case "auth/invalid-email":
        errorMessage = "El email ingresado tiene formato incorrecto";
        break;
      case "auth/user-not-found":
        errorMessage = "El email ingresado no pertenece a ningún usuario";
        break;
      default:
        errorMessage = "Error al ingresar email o contraseña";
        break;
    }
    yield put(loginFailure(errorMessage));
    yield put(loginClear());
  }
}

export function* recoverPasswordSaga(action) {
  try {
    const { email } = action.payload;
    const authFunction = yield call(firebase.auth);
    yield call([authFunction, authFunction.sendPasswordResetEmail], email);
    yield put(recoverPasswordSuccess());
    alert("Email de recuperación de contraseño enviado");
  } catch (error) {
    alert("Error al ingresar email para recuperar contraseña");
    yield put(recoverPasswordFailure(error.message));
  }
}

export function* logoutSaga() {
  try {
    const authFunction = yield call(firebase.auth);
    yield call([authFunction, authFunction.signOut]);
    yield localStorage.removeItem("token");
    yield localStorage.removeItem("tokenExpiration");
    yield put(logoutSuccess());
  } catch (error) {
    yield put(logoutFailure(error.message));
  }
}

export function* refreshTokenSaga() {
  try {
    const expirationTime = yield localStorage.getItem("tokenExpiration");
    yield delay(expirationTime - new Date().getTime());
    const user = yield call(onAuthStateChanged);
    const token = yield user.getIdToken(true);
    yield localStorage.setItem("token", token);
    yield localStorage.setItem(
      "tokenExpiration",
      new Date().getTime() + 1000 * 60 * 50 // 50 mins
    );
    yield put(refreshTokenSaga_());
  } catch (error) {
    console.log("error", error);
  }
}



// WEBPACK FOOTER //
// ./src/stores/sagas/auth.js